import type { DailyUserStatByUserStatusDTO } from '../userStat.types';
import { injectable } from 'inversify';
import API from '@repositories/Axios';
import type { IUserStatRepository } from '../IUserStatRepository';

@injectable()
export class UserStatRepository implements IUserStatRepository {
  async getStat(): Promise<DailyUserStatByUserStatusDTO> {
    const result = await API.get<DailyUserStatByUserStatusDTO>(`/api/v1/statistics/daily-user-status-aggregate-top5`);
    return result.data;
  }
}
